/**
 * WebMCP (Web Model Context Protocol) - Boutique NOPE
 *
 * Enregistre des tools via navigator.modelContext pour exposer
 * les fonctionnalités du store aux agents IA (Chrome 146+).
 * Annote dynamiquement les formulaires existants avec toolname/tooldescription.
 *
 * @see https://www.semrush.com/blog/webmcp/
 */
(function () {
  'use strict';

  var routes = window.theme && window.theme.routes ? window.theme.routes : {};
  var rootUrl = routes.root_url || '/';

  // Imperative API support detected once. Tools qui ont une version impérative
  // (retour Promise propre via fetch JSON) doivent skip leur annotation déclarative
  // pour éviter les doublons.
  var HAS_IMPERATIVE_API = !!(navigator.modelContext && typeof navigator.modelContext.addTool === 'function');
  //var HAS_IMPERATIVE_API = false;

  // ── Debug mode ──────────────────────────────────────────
  // Activate via: ?webmcp_debug=1  or  localStorage.setItem('webmcp_debug', '1')

  var DEBUG = (
    window.location.search.indexOf('webmcp_debug=1') !== -1 ||
    (window.localStorage && localStorage.getItem('webmcp_debug') === '1')
  );


  // Persist debug flag if activated via URL
  if (window.location.search.indexOf('webmcp_debug=1') !== -1 && window.localStorage) {
    localStorage.setItem('webmcp_debug', '1');
  }

  var debugLog = {
    formsAnnotated: [],
    toolsRegistered: [],
    metaInjected: [],
    warnings: [],
    modelContextSupported: false
  };

  function dbg(category, message) {
    if (!DEBUG) return;
    if (category === 'form') debugLog.formsAnnotated.push(message);
    else if (category === 'tool') debugLog.toolsRegistered.push(message);
    else if (category === 'meta') debugLog.metaInjected.push(message);
    else if (category === 'warn') debugLog.warnings.push(message);
  }

  function printDebugSummary() {
    if (!DEBUG) return;

    var line = '─────────────────────────────────────────────';
    var report = [];

    report.push('');
    report.push(line);
    report.push('  WEBMCP DEBUG REPORT');
    report.push(line);
    report.push('');

    // Model Context API
    report.push('  navigator.modelContext: ' + (debugLog.modelContextSupported ? 'YES' : 'NO (Chrome 146+ required)'));
    report.push('');

    // Forms
    report.push('  FORMS ANNOTATED: ' + debugLog.formsAnnotated.length);
    if (debugLog.formsAnnotated.length === 0) {
      report.push('    (none found on this page)');
    } else {
      debugLog.formsAnnotated.forEach(function (f, i) {
        report.push('    [' + (i + 1) + '] ' + f.element);
        report.push('        toolname="' + f.toolname + '"');
        report.push('        tooldescription="' + f.tooldescription + '"');
      });
    }
    report.push('');

    // Tools
    report.push('  TOOLS REGISTERED: ' + debugLog.toolsRegistered.length);
    if (!debugLog.modelContextSupported) {
      report.push('    (skipped — no modelContext)');
    } else {
      debugLog.toolsRegistered.forEach(function (t) { report.push('    - ' + t); });
    }
    report.push('');

    // Meta
    report.push('  META INJECTED: ' + debugLog.metaInjected.length);
    debugLog.metaInjected.forEach(function (m) { report.push('    - ' + m); });
    report.push('');

    // Warnings
    if (debugLog.warnings.length > 0) {
      report.push('  WARNINGS:');
      debugLog.warnings.forEach(function (w) { report.push('    ! ' + w); });
      report.push('');
    }

    report.push('  Disable: localStorage.removeItem("webmcp_debug")');
    report.push(line);
    report.push('');

    console.log(report.join('\n'));
  }

  // ── Helpers ──────────────────────────────────────────────

  function fetchJSON(url, options) {
    return fetch(url, Object.assign({ headers: { Accept: 'application/json' } }, options))
      .then(function (r) { return r.json(); });
  }

  // ── 1. Declarative API — Annotate existing forms ────────

    function annotateExistingForms() {
      return;
    var formMappings = [
      { selector: 'form[action*="/cart/add"]:not(.installment)', name: 'add_to_cart', desc: 'Add the selected product variant to the shopping cart. Requires a variant ID and quantity.', autosubmit: true, skipIfImperative: true },
      { selector: 'form[action*="/search"]', name: 'search_store', desc: 'Search the store for products by keyword.', autosubmit: true, skipIfImperative: true },
      { selector: 'form[action*="/contact"]', name: 'contact_store', desc: 'Send a message to the store via the contact form.' },
      { selector: 'form[action*="subscribe"], form.email-signup-form, form.newsletter-form', name: 'newsletter_signup', desc: 'Subscribe to the store newsletter with an email address.', autosubmit: true },
      { selector: 'form[action*="/account/login"]', name: 'customer_login', desc: 'Log in to a customer account with email and password.' }
    ];

    document.querySelectorAll('product-add-to-cart-sticky [form], .variant-selects--sticky [form]').forEach(function (el) {
      el.removeAttribute('form');
    });

   formMappings.forEach(function (mapping) {
      if (mapping.skipIfImperative && HAS_IMPERATIVE_API) return;
      document.querySelectorAll(mapping.selector).forEach(function (form) {
        if (!form.getAttribute('toolname')) {
          // Mettre les attributs seulement si le browser supporte WebMCP
          if (HAS_IMPERATIVE_API || navigator.modelContext) {
            try {
              form.setAttribute('toolname', mapping.name);
                form.setAttribute('tooldescription', mapping.desc);
                if (mapping.autosubmit) form.setAttribute('toolautosubmit', '');
              } catch (e) {
                // browser ne supporte pas ces attributs
              }
          }

          var idAttr = form.getAttribute('id');
          var id = idAttr ? '#' + idAttr : '';
          var cls = form.className ? '.' + form.className.trim().split(/\s+/).join('.') : '';
          var action = form.getAttribute('action') || '';
          var identifier = '<form' + id + cls + (action ? ' action="' + action + '"' : '') + '>';

          dbg('form', {
            element: identifier,
            toolname: mapping.name,
            tooldescription: mapping.desc
          });
        }
      });
    });
  }

  // ── 2. Imperative API — Register tools via navigator.modelContext ──

  function registerWebMCPTools() {
    debugLog.modelContextSupported = HAS_IMPERATIVE_API;
    if (!HAS_IMPERATIVE_API) {
      dbg('warn', 'navigator.modelContext.addTool not available — imperative tools skipped (declarative forms still work)');
      return;
    }

    var _addTool = navigator.modelContext.addTool.bind(navigator.modelContext);
    function addToolWithLog(config) {
      _addTool(config);
      dbg('tool', config.name + ' — ' + config.description.substring(0, 80));
    }

    // Tool: Search store (products)
    var currentQ = new URLSearchParams(window.location.search).get('q') || '';
    addToolWithLog({
      name: 'search_store',
      description: 'Search the store catalog for products by keyword. Returns product titles, prices, URLs, and images.',
      inputSchema: {
        type: 'object',
        properties: {
          query: {
            type: 'string',
            description: 'The search query (e.g. "tuque laine", "manteau hiver")',
            default: currentQ
          },
          limit: {
            type: 'number',
            description: 'Max number of results to return (default: 10, max: 20)'
          }
        },
        required: ['query']
      },
      execute: function (params) {
        var limit = Math.min(params.limit || 10, 20);
        var url = rootUrl + 'search/suggest.json?q=' + encodeURIComponent(params.query) + '&resources[type]=product&resources[limit]=' + limit;
        return fetchJSON(url).then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          return products.map(function (p) {
            return {
              title: p.title,
              url: rootUrl.replace(/\/$/, '') + p.url,
              price: p.price,
              image: p.image,
              vendor: p.vendor
            };
          });
        });
      }
    });

    // Tool: Get product details (current page)
    addToolWithLog({
      name: 'get_current_product',
      description: 'Get full details of the product currently displayed on the page, including all variants, prices, and availability.',
      inputSchema: {
        type: 'object',
        properties: {}
      },
      execute: function () {
        var productData = document.querySelector('[data-product-json], script[data-product-json], [id="ProductJson"], script.product-json');
        if (productData) {
          try { return JSON.parse(productData.textContent); } catch (e) { /* fall through */ }
        }
        // Fallback: fetch from Shopify JSON endpoint
        var path = window.location.pathname;
        if (path.indexOf('/products/') === -1) {
          return { error: 'Not on a product page' };
        }
        return fetchJSON(path + '.json').then(function (data) { return data.product; });
      }
    });

    // Tool: Get product by handle
    addToolWithLog({
      name: 'get_product',
      description: 'Fetch details for a specific product by its handle (URL slug). Returns title, description, variants, images, and pricing.',
      inputSchema: {
        type: 'object',
        properties: {
          handle: {
            type: 'string',
            description: 'The product handle / URL slug (e.g. "tuque-merino-classic")'
          }
        },
        required: ['handle']
      },
      execute: function (params) {
        return fetchJSON(rootUrl + 'products/' + encodeURIComponent(params.handle) + '.json')
          .then(function (data) { return data.product; });
      }
    });

    // Tool: Add to cart
    addToolWithLog({
      name: 'add_to_cart',
      description: 'Add one or more product variants to the shopping cart.',
      inputSchema: {
        type: 'object',
        properties: {
          items: {
            type: 'array',
            description: 'Array of items to add',
            items: {
              type: 'object',
              properties: {
                id: { type: 'number', description: 'The variant ID to add' },
                quantity: { type: 'number', description: 'Quantity (default: 1)' }
              },
              required: ['id']
            }
          }
        },
        required: ['items']
      },
      execute: function (params) {
        var items = params.items.map(function (item) {
          return { id: item.id, quantity: item.quantity || 1 };
        });
        return fetch(routes.cart_add_url || rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) { return r.json(); });
      }
    });

    // Tool: Get cart contents
    addToolWithLog({
      name: 'get_cart',
      description: 'Retrieve the current shopping cart contents including items, quantities, and total price.',
      inputSchema: {
        type: 'object',
        properties: {}
      },
      execute: function () {
        return fetchJSON(routes.cart_url ? routes.cart_url + '.js' : rootUrl + 'cart.js');
      }
    });

    // Tool: Update cart item quantity
    addToolWithLog({
      name: 'update_cart_item',
      description: 'Update the quantity of an item already in the cart. Set quantity to 0 to remove it.',
      inputSchema: {
        type: 'object',
        properties: {
          id: { type: 'string', description: 'The variant ID or line item key' },
          quantity: { type: 'number', description: 'New quantity (0 to remove)' }
        },
        required: ['id', 'quantity']
      },
      execute: function (params) {
        return fetch(routes.cart_change_url || rootUrl + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: params.id, quantity: params.quantity })
        }).then(function (r) { return r.json(); });
      }
    });

    // Tool: Browse collection
    addToolWithLog({
      name: 'browse_collection',
      description: 'Get products from a specific collection by its handle. Supports pagination.',
      inputSchema: {
        type: 'object',
        properties: {
          handle: {
            type: 'string',
            description: 'The collection handle / URL slug (e.g. "tuques", "manteaux", "solde")'
          },
          page: {
            type: 'number',
            description: 'Page number for pagination (default: 1)'
          }
        },
        required: ['handle']
      },
      execute: function (params) {
        var page = params.page || 1;
        return fetchJSON(rootUrl + 'collections/' + encodeURIComponent(params.handle) + '/products.json?page=' + page)
          .then(function (data) { return data.products; });
      }
    });

    // Tool: Get collections list
    addToolWithLog({
      name: 'list_collections',
      description: 'List all available product collections in the store.',
      inputSchema: {
        type: 'object',
        properties: {}
      },
      execute: function () {
        return fetchJSON(rootUrl + 'collections.json')
          .then(function (data) {
            return (data.collections || []).map(function (c) {
              return { title: c.title, handle: c.handle, url: rootUrl + 'collections/' + c.handle };
            });
          });
      }
    });

    // Context-aware: register product-specific tools only on product pages
    if (window.location.pathname.indexOf('/products/') !== -1) {
      addToolWithLog({
        name: 'get_product_recommendations',
        description: 'Get recommended products related to the currently viewed product.',
        inputSchema: {
          type: 'object',
          properties: {}
        },
        execute: function () {
          var productId = window.theme && window.theme.settings && window.theme.settings.product_id;
          if (!productId) return { error: 'No product ID found on this page' };
          return fetchJSON(rootUrl + 'recommendations/products.json?product_id=' + productId + '&limit=8')
            .then(function (data) { return data.products; });
        }
      });
    }
  }

  // ── 3. Structured metadata injection ────────────────────

  function injectLLMMetadata() {
    // Add llms.txt link if not already present
    if (!document.querySelector('link[rel="llms-txt"]')) {
      var link = document.createElement('link');
      link.rel = 'llms-txt';
      link.type = 'text/plain';
      link.href = rootUrl + 'pages/llms-txt';
      document.head.appendChild(link);
      dbg('meta', '<link rel="llms-txt"> → ' + link.href);
    }

    // Add WebMCP availability meta tag
    if (!document.querySelector('meta[name="webmcp"]')) {
      var meta = document.createElement('meta');
      meta.name = 'webmcp';
      meta.content = 'supported';
      document.head.appendChild(meta);
      dbg('meta', '<meta name="webmcp" content="supported">');
    }

    // Add structured context about the current page for agents
    if (!document.querySelector('meta[name="ai-context"]')) {
      var context = '';
      var pageType = document.body.className.match(/template-(\S+)/);
      if (pageType) {
        context = 'page_type=' + pageType[1];
      }
      if (context) {
        var aiMeta = document.createElement('meta');
        aiMeta.name = 'ai-context';
        aiMeta.content = context;
        document.head.appendChild(aiMeta);
        dbg('meta', '<meta name="ai-context" content="' + context + '">');
      }
    }
  }

  // ── Init ─────────────────────────────────────────────────

  function init() {
    injectLLMMetadata();
    annotateExistingForms();
    registerWebMCPTools();
    printDebugSummary();

    // Re-annotate forms after Shopify section rendering (dynamic content)
    document.addEventListener('shopify:section:load', function () {
      annotateExistingForms();
    });

    // Observe DOM mutations to catch dynamically added forms
    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        var hasNewForms = mutations.some(function (m) {
          return Array.from(m.addedNodes).some(function (n) {
            return n.nodeType === 1 && (n.tagName === 'FORM' || n.querySelector && n.querySelector('form'));
          });
        });
        if (hasNewForms) annotateExistingForms();
      });

      var observeTarget = document.querySelector('main') || document.body;
      observer.observe(observeTarget, { childList: true, subtree: true });

      // Cleanup avant BFCache freeze
      window.addEventListener('pagehide', function () {
        observer.disconnect();
      });

    }
  }


  // Run after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  
})();
